import { createSlice } from "@reduxjs/toolkit";

export const PageTitleSlice = createSlice({
  name: "PageTitle",
  initialState: {
    title: "",
    hasBackIcon: false,
    hasTitleRoute: false,
    route: "",
  },
  reducers: {
    setPageTitle: (state, { payload }) => {
      state.title = payload;
    },
    setBackIcon: (
      state,
      { payload: { hasBackIcon = false, route = "", hasTitleRoute = false } }
    ) => {
      state.hasBackIcon = hasBackIcon;
      state.route = route;
      state.hasTitleRoute = hasTitleRoute;
    },
  },
});

export const { setPageTitle, setBackIcon } = PageTitleSlice.actions;

export const PageTitleReducer = PageTitleSlice.reducer;
